import React from "react";
import Chip from "@mui/material/Chip";
import { useTheme } from "@mui/material";

const NotificationStatusChip = ({ label }) => {
  const theme = useTheme();
  const getStatusColor = (status) => {
    switch (status.toLowerCase()) {
      case "delivered":
      case "success":
        return {
          color: theme.palette.success?.dark,
          background: theme.palette.success?.main,
        };
      case "bounce":
      case "dropped":
      case "spamreport":
      case "failed":
      case "deferred":
      case "unsubscribe":
      case "group_unsubscribe":
        return {
          color: theme.palette.error?.dark,
          background: theme.palette.error?.main,
        };
      case "processed":
        return {
          color: theme.palette.warning?.dark,
          background: theme.palette.warning?.main,
        };
      case "open":
      case "click":
        return {
          color: theme.palette.info.main,
          background: theme.palette.info.lightest,
        };
      case "pending":
        return {
          color: theme.palette.warning?.darkest,
          background: theme.palette.warning?.light,
        };
      default:
        return {
          color: theme.palette.info.main,
          background: theme.palette.info.lightest,
        };
    }
  };

  return (
    <Chip
      label={label}
      sx={{
        ...getStatusColor(label),
        width: "fit-content",
      }}
      size="small"
    />
  );
};

export default React.memo(NotificationStatusChip);
